module.exports = __webpack_public_path__ + "static/media/RemoveCuvetteLid.4a214fd4.svg";